module.exports = __webpack_public_path__ + "fonts/Gibson-Bold.3bc19d34.eot";